module.exports = __webpack_public_path__ + "static/media/radio_button_checked.f35fda64.svg";